module.exports = __webpack_public_path__ + "static/t1-6c5c56f5be7143691ff6d761fafbf44b.pdf";